module.exports = __webpack_public_path__ + "img/XK.b07eb629.png";